import { RootState } from 'editor/src/store/index';

const getLayoutSchemaByName = (state: RootState, schemaName: string) =>
  state.editorModules.layouts.schemas.find((schema) => schema.name === schemaName);

export default getLayoutSchemaByName;
